<template>
	<CFinancialCard :quarterInfo="quarterInfo">
		<p class="wrapper-title">{{ $t('enterprise.quarter-title.financial-indicators') }}</p>
		<p class="financial-more" @click="gotoFinancialData">
			{{ $t('enterprise.more') }} <i class="iconfont iconjiantouyou"></i>
		</p>
	</CFinancialCard>
</template>

<script setup>
import CFinancialCard from './c-financial-card.vue';
import { useNavigation } from '@rebuild/hooks/useNavigation';

defineProps({
	quarterInfo: {
		type: Object,
		default: () => {}
	}
});

const { goToModule } = useNavigation();
const gotoFinancialData = () => {
	goToModule('finance_data', { r: new Date().getTime() });
};
</script>
